<div class="venue-capacity-dialog">
  <div class="modal-header-custom d-flex flex-row">
    <mat-icon (click)="close()" class="close">close</mat-icon>
  </div>
  <div class="row">
    <div class="col-12">
    <app-capacity [labelName]="('VENUES.MAX_GUEST_CAPACITY' | translate)" [numberOfGuests]="capacity"
                    (shareCapacity)="shareCapacity($event)"></app-capacity>
    </div>
  </div>
  <button type="button" class="update-venue-capacity-btn mat-raised-button" (click)="save()">{{
    'VENUES.EDIT_CAPACITY' | translate }}</button>
</div>
